import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { ProjectRole } from '../../../models/userRole.model';
import { IUserService } from '../../user/user.service';

interface IProps {
  allowedRoles: ProjectRole[];
}

export const RedirectFromAnnotationContainer = observer((props: IProps): ReactElement => {
  const userService = useInjection(IUserService.$);

  const { projectId } = useParams<{ projectId: string }>();
  const redirect = !userService.isInRole(projectId, props.allowedRoles);

  return <>{redirect && <Redirect to='/' />}</>;
});
